<template>
  <div>
    <div
      id="kt_subheader"
      class="subheader py-2 py-lg-4 mb-5 gutter-b subheader-solid"
    >
      <div
        class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
      >
        <!--begin::Info-->
        <div class="d-flex align-items-center flex-wrap mr-2">
          <!--begin::Page Title-->
          <h5 class="text-dark font-weight-bold mt-2 mb-2 mr-5">
            Product Data Management- Channels
          </h5>
          <!--end::Page Title-->
          <!--begin::Action-->
          <div
            class="subheader-separator subheader-separator-ver mt-2 mb-2 mr-4 bg-gray-200"
          ></div>
          <span class="text-muted font-weight-bold mr-4"> </span>
          <div
            class="subheader-separator subheader-separator-ver mt-2 mb-2 mr-4 bg-gray-200"
          ></div>
          <!--end::Action-->
        </div>
        <div class="d-flex align-items-center">
          <v-btn href="/pim/channels/new" class="btn btn-success mr-2"
            >Import Manager
          </v-btn>
        </div>
        <!--end::Info-->
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <v-card class="h-100"  height="100" color="#386498">
            <v-row align="center" justify="center">
              <v-col class="text-center" cols="12">
                <h4 class="display-3 text-white  mb-4">Import Manager</h4>
              </v-col>
            </v-row>
          </v-card>
        </div>
        <div class="col-lg-6">
          <v-card class="h-100">
            <v-card-title align="left">
              <p class="text-wrap">
                Download Import Template
              </p>
              <v-spacer> </v-spacer>

              <div class="col-7">
                <select id="File Name" class="form-control">
                  <option>Choose Template</option>
                  <option>XML</option>
                  <option>CSV</option>
                </select>
              </div>
              <div class="col-5">
                <v-btn href="/pim/channels/new" class="btn btn-success mr-2"
                  >Download
                </v-btn>
              </div>
            </v-card-title>
          </v-card>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <v-container fluid>
            <v-row dense>
              <v-col v-for="card in cards" :key="card.title" :cols="card.flex">
                <v-card
                  color="#385F73"
                  :img="card.src"
                  height="160px"
                  :href="card.detail"
                >
                  <v-card-title
                    class="headline h2 text-white"
                    v-text="card.title"
                  ></v-card-title>
                  <v-card-subtitle
                    class="text-white "
                    v-text="card.short_description"
                  ></v-card-subtitle>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <div class="text-center">
                    
                      <v-btn :href="card.url" class="ma-2" tile light="success">
                        <v-icon left>mdi-pencil</v-icon> Import
                      </v-btn>
                    </div>
                  </v-card-actions>
                </v-card>
              </v-col>
          
            </v-row>
          </v-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    cards: [
      {
        title: "Upload CSV",
        src: "/media/header-green.jpg",
        color: "#111111",
        url: "/pim/channels/edit",
        detail: "/pim/channels/detail",
        short_description: "The B2B Marketplace for your Customers",
        delete: "false",
        flex: 6,
      },
      {
        title: "Upload XML",
        src: "/media/header2.jpg",
        color: "#111111",
        url: "/pim/channels/edit",
        short_description: "Our Website on Shopify or B2B",
        detail: "/pim/channels/detail",
        flex: 6,
      },

      {
        title: "Shopify",
        src: "/media/header-black.jpg",
        short_description: "Import from Shopify Export",

        url: "/pim/channels/edit",
        detail: "/pim/channels/detail",
        flex: 6,
      },
    ],

    open: ["public"],
  }),
};
</script>
